import * as z from "zod";

export const Tenant = z.enum([
    "albertine",
    "hugoboss",
    "mastercard",
    "carlo",
    "visa-i2",
    "revolut",
]);
export type Tenant = z.infer<typeof Tenant>;

export function isTenant(possibleTenant: unknown): possibleTenant is Tenant {
    return Tenant.safeParse(possibleTenant).success;
}
